<script>
  import { stepStore } from '../stores.js';

  let step;                   // Number : keep track of stepStore value
  
  export let label = '&nbsp;';// String : any
  export let action = 'inc';  // String : inc | dec | reset

  export let min = null;      // Number : will limit decrease if defined
  export let max = null;      // Number : will limit increase if defined

  let handleClick;            // Function

  let disabled = false;       // Bool : disable button when limits are met

  const unsubscribe = stepStore.subscribe(value => {
    step = value;
    if      ( min && value <= min ) disabled = true
    else if ( max && value >= max ) disabled = true
    else                            disabled = false
  });

  function increase() { stepStore.update( n => n + 1 ) }
  function decrease() { stepStore.update( n => n - 1 ) }
	function reset()    { stepStore.set( 0 ) }
  
  switch (action) {
    case 'inc':   handleClick = increase; break;
    case 'dec':   handleClick = decrease; break;
    case 'reset': handleClick = reset;    break;
  }
</script>

<button 
  on:click={handleClick} 
  {disabled}
  class:left={action=='dec'}
  class:right={action=='inc'}
  >
	{@html label}
</button>

<style>
  button {
    outline: none;
    display: inline-block;
    height: 3rem;
    width: 3rem;
    font-size: 1.5rem;
    line-height: 1.5rem;
    cursor: pointer;
    font-weight: bold;
    border: 0;
    border-radius: 0;
    /* color: var(--color-blue-dark);
    background-color: var(--color-accent-yellow); */
    color: var(--color-blue-dark);
    background-color: var(--color-blue-light-4);
    position: relative; /* enable ::before size */
    vertical-align: top;
    margin: 0;
  }

  /* .right {
    height: 6rem;
    width: 6rem;
    font-size: 3rem;
    line-height: 3rem;
  } */

  button:hover {
    /* color: var(--color-accent-yellow);
    background-color: var(--color-blue-dark); */
    color: var(--color-white);
    background-color: var(--color-blue-dark);
  }

  button:active {
    /* color: var(--color-accent-yellow);
    background-color: var(--color-blue-light); */
    color: var(--color-accent-yellow);
    background-color: var(--color-blue-dark);
  }

  button[disabled] {
    color: var(--color-blue-light-4);
    background-color: var(--color-blue-light-5);
    cursor: auto;
  }

  .left::before,
  .right::before {
    content: '';
    position: absolute;
    left: 50%;
    top: 53%;
    width: 20%;
    height: 20%;
    transform: translate(-50%, -50%) rotate(45deg);
    border-style: solid;
    /* border-color: var(--color-blue-dark); */
  }

  .left::before {
    left: 55%;
    border-width: 0 0 3px 3px;
  }

  .right::before {
    left: 45%;
    border-width: 3px 3px 0 0;
  }
</style>
